import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

export default {
    name : 'swiper-caroussel',

    init() {
        const items = document.querySelectorAll('.swiper--caroussel');
        if (items.length) {
            setTimeout(() => this.run(items), 100);
        }
    },

    run(swiperCollection)
    {
        swiperCollection.forEach((element) => {
            const config = element.dataset.config ?? 'small';
            new Swiper('#'+element.id, this.getConfig(element.id, config));
        });
    },

    getConfig(sliderId, keyword) {
        console.log(keyword);
        return keyword === 'small' ?
            this.getSmallConfig(sliderId) :
            this.getGalleryConfig(sliderId)
    },

    getSmallConfig(sliderId) {
        return {
            navigation: {
                nextEl: '#'+sliderId+ " .swiper-button-next",
                prevEl: '#'+sliderId + " .swiper-button-prev",
            },

            scrollbar: {
                el: '#'+sliderId+" .swiper-scrollbar",
                hide: false,
            },

            spaceBetween: 10,

            breakpoints: {
                768: {
                    freeMode: false,
                    slidesPerView: 3,
                },

                1200: {
                    centeredSlides: false,
                    slidesPerView: 6,
                }
            },
        }
    },

    getGalleryConfig(sliderId) {
        return {
            slidesPerView: 1,
            autoHeight: false,
            navigation: {
                nextEl: '#'+sliderId+ " .swiper-button-next",
                prevEl: '#'+sliderId + " .swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
        }
    }


    } // export